// extracted by mini-css-extract-plugin
export default {"customerTitle":"ConfirmDeleteModal_customerTitle__xptN+","customerLabel":"ConfirmDeleteModal_customerLabel__P8XuT","customerBtn":"ConfirmDeleteModal_customerBtn__ffiXt"};